import { Box, Flex, Modal as MantineModal } from '@mantine/core'

import { Button } from '@/components/Button/Button'
import type { ConfirmationModalProps } from '@/components/ConfirmationModal/ConfirmationModal.types'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import classes from './ConfirmationModal.module.css'

export function ConfirmationModal({
  button,
  description,
  isLoading,
  onClose,
  onConfirm,
  opened,
  title,
  ...props
}: ConfirmationModalProps) {
  return (
    <MantineModal
      onClose={onClose}
      opened={opened}
      radius={8}
      size="xl"
      withCloseButton={false}
      {...props}
      classNames={classes}
    >
      <Box ta="center">
        <Title variant="h1">{title}</Title>

        <Text>{description}</Text>
      </Box>

      <Flex
        direction={{ base: 'column', sm: 'row' }}
        gap={16}
        justify="center"
        mt={32}
      >
        <Button onClick={onClose} variant="outline">
          {props.cancelLabel || 'Cancel'}
        </Button>

        <Button
          loading={isLoading}
          onClick={onConfirm}
          variant={button.variant}
        >
          {button.label}
        </Button>
      </Flex>
    </MantineModal>
  )
}
